import { render, staticRenderFns } from "./basketballLeagueFull_cba.vue?vue&type=template&id=193c69d6"
import script from "./basketballLeagueFull_cba.vue?vue&type=script&lang=js"
export * from "./basketballLeagueFull_cba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports